const closeModal = ($modal) => {
  $modal.classList.remove("is-active");
};

document.querySelectorAll(".modal-close").forEach(($el) => {
  $el.addEventListener("click", (event) => {
    event.preventDefault();
    closeModal($el.closest(".modal"));
  });
});

document.querySelector("body").addEventListener("keydown", (event) => {
  if (event.key === "Escape") {
    document.querySelectorAll(".modal").forEach(($modal) => {
      closeModal($modal);
    });
  }
});
